var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","fill-height":""}},[_c('v-flex',{attrs:{"grow":""}},[_c('MultiChartWithSharedRange',{attrs:{"charts":_vm.charts,"times":_vm.times,"selected-time":_vm.selectedTime}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }